package de.connect2x.timmy.brandings.aokTheme

import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import de.connect2x.messenger.compose.view.theme.ThemeTypography
import de.connect2x.messenger.compose.view.theme.withFontFamily
import de.connect2x.timaokwebclient.generated.resources.Res
import de.connect2x.timaokwebclient.generated.resources.AOKBuenosAires_Bold
import de.connect2x.timaokwebclient.generated.resources.AOKBuenosAires_BoldItalic
import de.connect2x.timaokwebclient.generated.resources.AOKBuenosAires_Regular
import de.connect2x.timaokwebclient.generated.resources.AOKBuenosAires_RegularItalic
import de.connect2x.timaokwebclient.generated.resources.AOKBuenosAires_SemiBold
import de.connect2x.timaokwebclient.generated.resources.AOKBuenosAires_SemiBoldItalic
import org.jetbrains.compose.resources.Font

class ThemeTypographyAOKImpl : ThemeTypography {
    @Composable
    override fun create(): Typography {
        return Typography().withFontFamily(
            FontFamily(
                fonts = listOf(
                    // --- Regular (200-400) -------------------------------------------------------
                    Font(Res.font.AOKBuenosAires_Regular, FontWeight.ExtraLight, FontStyle.Normal),
                    Font(Res.font.AOKBuenosAires_RegularItalic, FontWeight.ExtraLight, FontStyle.Italic),

                    Font(Res.font.AOKBuenosAires_Regular, FontWeight.Normal, FontStyle.Normal),
                    Font(Res.font.AOKBuenosAires_RegularItalic, FontWeight.Normal, FontStyle.Italic),

                    Font(Res.font.AOKBuenosAires_Regular, FontWeight.Light, FontStyle.Normal),
                    Font(Res.font.AOKBuenosAires_RegularItalic, FontWeight.Light, FontStyle.Italic),

                    // --- SemiBold (500-600) -------------------------------------------------------
                    Font(Res.font.AOKBuenosAires_SemiBold, FontWeight.Medium, FontStyle.Normal),
                    Font(Res.font.AOKBuenosAires_SemiBoldItalic, FontWeight.Medium, FontStyle.Italic),

                    Font(Res.font.AOKBuenosAires_SemiBold, FontWeight.SemiBold, FontStyle.Normal),
                    Font(Res.font.AOKBuenosAires_SemiBoldItalic, FontWeight.SemiBold, FontStyle.Italic),

                    // --- Bold (700-900) -----------------------------------------------------------
                    Font(Res.font.AOKBuenosAires_Bold, FontWeight.Bold, FontStyle.Normal),
                    Font(Res.font.AOKBuenosAires_BoldItalic, FontWeight.Bold, FontStyle.Italic),

                    Font(Res.font.AOKBuenosAires_Bold, FontWeight.ExtraBold, FontStyle.Normal),
                    Font(Res.font.AOKBuenosAires_BoldItalic, FontWeight.ExtraBold, FontStyle.Italic),

                    Font(Res.font.AOKBuenosAires_Bold, FontWeight.Black, FontStyle.Normal),
                    Font(Res.font.AOKBuenosAires_BoldItalic, FontWeight.Black, FontStyle.Italic),
                )
            )
        )
    }
}
